import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="w9-form"
export default class extends Controller {
  static targets = ["otherFields", "llcFields", "taxClassification", "businessNameField", "ssnField", "einField"]
  static values = { enrollmentType: String }

  connect() {
    // Initialize visibility based on current selection
    this.toggleClassificationFields()
    this.toggleEnrollmentTypeFields()
  }

  toggleClassificationFields() {
    // Get the tax classification value from the select element
    const taxClassification = this.taxClassificationTarget.value

    // Show/hide "Other" classification input
    if (taxClassification === 'Other') {
      this.otherFieldsTarget.classList.remove('hidden')
      const input = this.otherFieldsTarget.querySelector('input')
      if (input) input.required = true
    } else {
      this.otherFieldsTarget.classList.add('hidden')
      const input = this.otherFieldsTarget.querySelector('input')
      if (input) input.required = false
    }

    // Show/hide LLC tax classification input
    if (taxClassification === 'Limited Liability Company (LLC)') {
      this.llcFieldsTarget.classList.remove('hidden')
      const select = this.llcFieldsTarget.querySelector('select')
      if (select) select.required = true
    } else {
      this.llcFieldsTarget.classList.add('hidden')
      const select = this.llcFieldsTarget.querySelector('select')
      if (select) select.required = false
    }
  }

  toggleEnrollmentTypeFields() {
    // Only apply enrollment type logic if enrollment type is set
    if (!this.hasEnrollmentTypeValue || !this.enrollmentTypeValue) {
      return
    }

    const isPersonal = this.enrollmentTypeValue === 'Personal'
    const isBusiness = this.enrollmentTypeValue === 'Business'

    // Business Name: show only for business
    if (this.hasBusinessNameFieldTarget) {
      if (isBusiness) {
        this.businessNameFieldTarget.classList.remove('hidden')
        const input = this.businessNameFieldTarget.querySelector('input')
        if (input) input.required = true
      } else {
        this.businessNameFieldTarget.classList.add('hidden')
        const input = this.businessNameFieldTarget.querySelector('input')
        if (input) {
          input.required = false
          input.value = ''
        }
      }
    }

    // SSN: show only for personal
    if (this.hasSsnFieldTarget) {
      if (isPersonal) {
        this.ssnFieldTarget.classList.remove('hidden')
        const input = this.ssnFieldTarget.querySelector('input')
        if (input) input.required = true
      } else {
        this.ssnFieldTarget.classList.add('hidden')
        const input = this.ssnFieldTarget.querySelector('input')
        if (input) {
          input.required = false
          input.value = ''
        }
      }
    }

    // EIN: show only for business
    if (this.hasEinFieldTarget) {
      if (isBusiness) {
        this.einFieldTarget.classList.remove('hidden')
        const input = this.einFieldTarget.querySelector('input')
        if (input) input.required = true
      } else {
        this.einFieldTarget.classList.add('hidden')
        const input = this.einFieldTarget.querySelector('input')
        if (input) {
          input.required = false
          input.value = ''
        }
      }
    }
  }

  enrollmentTypeValueChanged() {
    this.toggleEnrollmentTypeFields()
  }

  formatSSN(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove non-digits

    // Format as XXX-XX-XXXX
    if (value.length > 3 && value.length <= 5) {
      value = value.slice(0, 3) + '-' + value.slice(3)
    } else if (value.length > 5) {
      value = value.slice(0, 3) + '-' + value.slice(3, 5) + '-' + value.slice(5, 9)
    }

    event.target.value = value
  }

  formatEIN(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove non-digits

    // Format as XX-XXXXXXX
    if (value.length > 2) {
      value = value.slice(0, 2) + '-' + value.slice(2, 9)
    }

    event.target.value = value
  }
}
